import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { VillageDeviceOccurrenceDto } from "./dtos/VillageDeviceOccurrenceDto";
import { Typography } from "@mui/material";
import { dataGridSx } from "../../styles/bhpStyles";


const columns: GridColDef[ ] = [ 

    {
        field: 'villageCount',
        headerName: 'Villages',
        width: 275,
    },
    
    {
        field: 'deviceCount',
        headerName: 'Devices',
        width: 275,
    },

];


type VillageDeviceOccurrenceStatsProps = {

    villageDeviceOccurrences: VillageDeviceOccurrenceDto[];

};


export const VillageDeviceOccurrenceStats: React.FC<VillageDeviceOccurrenceStatsProps> = ( props: VillageDeviceOccurrenceStatsProps ) => {

    const { villageDeviceOccurrences } = props;

    return(
        
        <>
        
            <Typography sx={{ marginTop: '30px', color: '#e65400', fontWeight: 'bold', fontSize: '25px' }}>Device Movement</Typography>

            {

                villageDeviceOccurrences.length === 0 
                    ? 
                <Typography sx={{ marginTop: '15px' }}>No device move villages to display</Typography>
                    :
                <DataGrid
                    getRowId={ _ => Math.floor( Math.random( ) * 100_000_000 ) }
                    hideFooterPagination
                    hideFooterSelectedRowCount
                    hideFooter
                    rows={ villageDeviceOccurrences }
                    columns={ columns }
                    autoHeight={ true }
                    sx={{ ...dataGridSx, width: 560, boxShadow: 5, marginTop: '5px !important' }}
                    sortingOrder={ [ 'desc', 'asc' ]}
                    disableSelectionOnClick
                />

            }

        </>

    );

};